module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "highscores"
  }, [_c('div', {
    staticClass: "highscores__modal"
  }, [_c('h3', [_vm._v("Highscores")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "highscores__modal__records"
  }, _vm._l((_vm.highscores), function(record, index) {
    return _c('div', {
      staticClass: "highscores__modal__record"
    }, [_c('div', {
      staticClass: "rank",
      domProps: {
        "textContent": _vm._s(index + 1)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name",
      domProps: {
        "textContent": _vm._s(record.name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "action",
      on: {
        "click": function($event) {
          _vm.watchReplay(record.history)
        }
      }
    }, [_vm._v("Watch replay")]), _vm._v(" "), _c('div', {
      staticClass: "score",
      domProps: {
        "textContent": _vm._s(record.score)
      }
    })])
  })), _vm._v(" "), (_vm.score > 0) ? _c('div', {
    staticClass: "highscores__modal__result"
  }, [_c('div', {
    staticClass: "highscores__modal__result_score"
  }, [_vm._v("\n                Your score: "), _c('span', {
    staticClass: "highscores__modal__result__score__points",
    domProps: {
      "textContent": _vm._s(_vm.score)
    }
  })]), _vm._v(" "), ((_vm.resultIsHighscore && _vm.responseMessage == '')) ? _c('div', [_c('strong', [_vm._v("That's a highscore!")]), _vm._v(" "), _c('div', {
    staticClass: "highscores__modal__result__form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input-text",
    attrs: {
      "type": "text",
      "placeholder": "Enter your name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submitScore($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button btn-submit",
    on: {
      "click": _vm.submitScore
    }
  }, [_vm._v("Submit")])])]) : _vm._e(), _vm._v(" "), (_vm.responseMessage != '') ? _c('div', [_c('strong', {
    style: ({
      color: (_vm.responseStatus ? 'inherit' : '#B00B13')
    }),
    domProps: {
      "textContent": _vm._s(_vm.responseMessage)
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button btn-playagain",
    on: {
      "click": _vm.playAgain
    }
  }, [_vm._v("Play again")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "highscores__modal__title"
  }, [_c('div', {
    staticClass: "rank"
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "action"
  }), _vm._v(" "), _c('div', {
    staticClass: "score"
  }, [_vm._v("Score")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eb681b5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/highscores/highscores.vue
// module id = 17
// module chunks = 0